import { Component, inject, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";
import { fuseAnimations } from "@fuse/animations";
import { NavigationEnd, Router } from "@angular/router";
import { AppConsts } from "@shared/AppConsts";
import { differenceInCalendarDays, format } from "date-fns";
import { SubscriptionStatusCode } from "@api/core.models";
import { AppSessionService } from "@vadmin/account/auth";
import { takeUntil } from "rxjs/operators";
import { TranslationService } from "@shared/translation.service";

@Component({
    selector: "trial-message",
    templateUrl: "./trial-message.component.html",
    styleUrls: ["./trial-message.component.scss"],
    animations: fuseAnimations,
})
export class TrialMessageComponent implements OnDestroy {
    readonly l = inject(TranslationService).l;

    private _router = inject(Router);

    private _sessionService = inject(AppSessionService);

    private _unsubscribeAll: Subject<any>;

    trialPeriod: boolean = false;

    loaded: boolean = true;

    trialDaysLeftText: string;

    subscriptionPage: boolean;

    allowBuy: boolean;

    status: SubscriptionStatusCode;

    constructor() {
        this._unsubscribeAll = new Subject();

        this._sessionService.onTrialPayed.pipe(takeUntil(this._unsubscribeAll)).subscribe((tenantInfo) => {
            if (tenantInfo && tenantInfo.subscriptionInfo) {
                this.status = tenantInfo.subscriptionInfo.status.code;
                const daysDiff = differenceInCalendarDays(tenantInfo.subscriptionInfo.status.date, new Date());
                if (daysDiff < 0) {
                    this.trialDaysLeftText = `Seu teste gratuito expirou em <b>${format(
                        tenantInfo.subscriptionInfo.status.date,
                        "dd/MM/yyyy"
                    )}</b>`;
                } else {
                    this.trialDaysLeftText = `Seu teste gratuito expira em <b>${daysDiff} dias </b>`;
                }
                switch (this.status) {
                    case 0:
                    case 3:
                    case 71:
                        this.trialPeriod = true;
                        break;
                    case 1:
                        this.trialDaysLeftText = `Seu teste gratuito expirou em <b>${format(
                            tenantInfo.subscriptionInfo.status.date,
                            "dd/MM/yyyy"
                        )}</b>`;
                        this.trialPeriod = true;
                        break;
                    default:
                        this.trialPeriod = false;
                        break;
                }
                this.allowBuy = this._sessionService.isUserInRoleTenant(AppConsts.RolesNames.Admin);
            }
        });

        this._router.events.pipe(takeUntil(this._unsubscribeAll)).subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.subscriptionPage = event.url.indexOf("subscription") > -1;
            }
        });
    }

    ngOnInit(): void {}

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    pay(): void {
        this._router.navigate(["/checkout"], { queryParams: { returnUrl: this._router.url } }).then();
    }

    abandonCancellation() {
        this._router.navigate(["/abandon-cancellation"]).then();
    }
}
